export default __webpack_public_path__ + "static/media/bg-orange.7c536142.png";